// Module
var code = "<div class=nlgHealthCheckCompositeHealthInfoReason> <div class=row> <div class=col-xs-6 ng-repeat=\"healthInfo in reason.healthInfos\"> <nlg-health-info instance=reason.application info=healthInfo></nlg-health-info> </div> </div> </div>";
// Exports
module.exports = code;